<template>
    <div>
      <template v-if="type_mapped==='territorio'">
        <b-container class="scroll">
          <b-row v-if="type==='zona_gn'">
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código Zona">
                  <b-form-input :value="feature.properties.codigo_zona_gn" disabled>
                  </b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Nombre Zona">
                  <b-form-input :value="feature.properties.nombre_zona_gn" disabled>
                  </b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row v-if="type==='provincia'">
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código provincia">
                  <b-form-input :value="feature.properties.codigo_provincia_ine" disabled>
                  </b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Nombre provincia">
                  <b-form-input :value="feature.properties.nombre_provincia_ine" disabled>
                  </b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row v-if="type==='codigo_postal'">
            <b-col cols="4">
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código postal">
                  <b-form-input :value="feature.properties.codigo_postal" disabled>
                  </b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row v-if="type==='municipio'">
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Código municipio">
                <b-form-input :value="feature.properties.codigo_municipio_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Nombre municipio">
                <b-form-input :value="feature.properties.nombre_municipio_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Nombre provincia">
                <b-form-input :value="feature.properties.nombre_provincia_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Municipio NEDGIA">
                <b-form-input :value="feature.properties.municipio_gnd" disabled>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Código provincia">
                <b-form-input :value="feature.properties.codigo_provincia_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="box" style="margin-top:0px">
            <b-row>
                <b-col v-for="element in territorio_columns" v-bind:key="element"><strong>{{element}}</strong></b-col>
            </b-row>
            <b-row v-for="(row, index) in territorio" v-bind:key="index">
                <b-col v-for="(element, index2) in territorio_columns" v-bind:key="index2">
                  <b-row v-if="row[index2]">
                      <b-col>{{row[index2].title}}</b-col>
                      <b-col class="text-right">{{toSpanish(feature.properties[row[index2].value])}}</b-col>
                  </b-row>
                  <b-row v-else>
                      <b-col></b-col>
                      <b-col></b-col>
                  </b-row>
                </b-col>
            </b-row>
          </div>
          <div class="box">
            <b-row>
                <b-col><strong>Resumen Longitud Red</strong></b-col>
            </b-row>
            <b-row>
                <b-col></b-col>
                <b-col>
                  <strong>Distribución</strong>
                </b-col>
                <b-col></b-col>
                <b-col>
                  <strong>Alta Presión</strong>
                </b-col>
            </b-row>
            <b-row>
                <b-col></b-col>
                <b-col>
                  <b-row>
                    <b-col><strong>GN</strong></b-col>
                    <b-col><strong>GP</strong></b-col>
                  </b-row>
                </b-col>
                <b-col></b-col>
                <b-col>
                  <b-row>
                    <b-col><strong>GN</strong></b-col>
                    <b-col><strong>GP</strong></b-col>
                  </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col>En servicio (m)</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.longitud_red_distribucion_gn_enservicio)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.longitud_red_distribucion_gp_enservicio)}}</b-col>
                  </b-row>
                </b-col>
                <b-col>En servicio (m)</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.longitud_red_transporte_gn_enservicio)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.longitud_red_transporte_gp_enservicio)}}</b-col>
                  </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col>No abandonada (m)</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.longitud_red_distribucion_gn_noabandonada)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.longitud_red_distribucion_gp_noabandonada)}}</b-col>
                  </b-row>
                </b-col>
                <b-col>No abandonada (m)</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.longitud_red_transporte_gn_noabandonada)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.longitud_red_transporte_gp_noabandonada)}}</b-col>
                  </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col>Total (m)</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.longitud_red_gn_distribucion)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.longitud_red_gp_distribucion)}}</b-col>
                  </b-row>
                </b-col>
                <b-col>Total (m)</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.longitud_red_gn_transporte)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.longitud_red_gp_transporte)}}</b-col>
                  </b-row>
                </b-col>
            </b-row>
          </div>
          <div class="box">
            <b-row>
                <b-col><strong>Resumen Acometidas</strong></b-col>
            </b-row>
            <b-row>
                <b-col></b-col>
                <b-col>
                  <strong>Distribución</strong>
                </b-col>
                <b-col></b-col>
                <b-col>
                  <strong>Alta Presión</strong>
                </b-col>
            </b-row>
            <b-row>
                <b-col></b-col>
                <b-col>
                  <b-row>
                    <b-col><strong>GN</strong></b-col>
                    <b-col><strong>GP</strong></b-col>
                  </b-row>
                </b-col>
                <b-col></b-col>
                <b-col>
                  <b-row>
                    <b-col><strong>GN</strong></b-col>
                    <b-col><strong></strong></b-col>
                  </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col>En servicio</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gn_distribucion_enservicio)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gp_distribucion_enservicio)}}</b-col>
                  </b-row>
                </b-col>
                <b-col>En servicio</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gn_transporte_enservicio)}}</b-col>
                    <b-col></b-col>
                  </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col>No abandonada</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gn_distribucion_noabandonada)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gp_distribucion_noabandonada)}}</b-col>
                  </b-row>
                </b-col>
                <b-col>No abandonada</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gn_transporte_noabandonada)}}</b-col>
                    <b-col></b-col>
                  </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col>Total</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gn_distribucion)}}</b-col>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gp_distribucion)}}</b-col>
                  </b-row>
                </b-col>
                <b-col>Total</b-col>
                <b-col>
                  <b-row>
                    <b-col>{{toSpanish(feature.properties.total_acometidas_gn_transporte)}}</b-col>
                    <b-col></b-col>
                  </b-row>
                </b-col>
            </b-row>
          </div>
        </b-container>
      </template>
      <template v-else-if="type_mapped==='red'">
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="IDI">
                <b-form-input :value="feature.id.split('.')[1]" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Provincia">
                <b-form-input :value="feature.properties.nombre_provincia_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Municipio">
                <b-form-input :value="feature.properties.nombre_municipio_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row v-for="(row, index) in red" v-bind:key="index">
          <b-col v-for="(col, index) in row" v-bind:key="index">
            <b-form>
              <b-form-group style="font-size: 1rem;" :label="col.title">
                <b-form-input :value="feature.properties[col.value]" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </template>

      <template v-else-if="type_mapped==='mun_red_desplazada'">
        <b-row>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Código municipio">
              <b-form-input :value="feature.properties.codigo_municipio_ine" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Nombre municipio">
              <b-form-input :value="feature.properties.nombre_municipio_ine" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Nombre provincia">
              <b-form-input :value="feature.properties.nombre_provincia_ine" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Código provincia">
              <b-form-input :value="feature.properties.codigo_provincia_ine" disabled>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
      <template v-else-if="type_mapped==='territorio_gn'">
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Código provincia">
                <b-form-input :value="feature.properties.codigo_provincia_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Provincia">
                <b-form-input :value="feature.properties.nombre_provincia_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col v-if="type != 'nucleo_urbano'">
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Tipo">
                <b-form-input :value="feature.properties.tipo" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Código municipio">
                <b-form-input :value="feature.properties.codigo_municipio_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Municipio">
                <b-form-input :value="feature.properties.nombre_municipio_ine" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col v-if="type != 'nucleo_urbano'">
            <b-form>
              <b-form-group style="font-size: 1rem;" label="Denominación">
                <b-form-input :value="feature.properties.denominacion" disabled>
                </b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </template>
      <template v-else-if="type_mapped==='comercial' || type_mapped==='caldera'">

        <div class='mb-3' v-if="errors.any('alta') || errors.any('identificacion') || errors.any('cambios_identificacion') || errors.any('gestion')">
          <strong style='color:red;'>¡Atención!</strong>
          <div v-if="errors.any('identificacion')">
            <span style='color:red;'>Hay errores en la pestaña <b>Identificación</b></span>
            <!-- <div style="white-space: pre-line;">{{ errors.all('gestion').join("\n") }}</div> -->
          </div>
          <div v-if="errors.any('alta')">
            <span style='color:red;'>Hay errores en la pestaña <b>Alta establecimiento</b></span>
          </div>
          <div v-if="errors.any('cambios_identificacion')">
            <span style='color:red;'>Hay errores en la pestaña <b>Cambios Identificación</b></span>
          </div>
          <div v-if="errors.any('gestion')">
            <span style='color:red;'>Hay errores en la pestaña <b>Gestión</b></span>
          </div>
        </div>

        <b-tabs>
          <b-tab v-if="newComercial" title="Alta establecimiento" :active="newComercial">
            <div class="scroll">
              <NewComercial ref="saveTab" @save="saveComercial" @close="close" :feature="feature" :type="type_mapped" :permisos="permisos"></NewComercial>
            </div>
          </b-tab>
          <b-tab v-if="!newComercial" title="Identificación" :active="!newComercial">
            <div class="scroll">
              <ComercialId ref="identificacionTab" @triggerComercialSave="triggerComercialSave" @calderaSaved="calderaSaved" @comercialSaved="comercialSaved" :feature="feature" :type="type_mapped" :permisos="permisos"></ComercialId>
            </div>
          </b-tab>
          <b-tab v-if="!newComercial" title="Cambios identificación">
            <div class="scroll">
              <template v-if="type_mapped==='caldera'">
                <br><span style="color:red"><strong>Esta caldera está en ZEUS, solicitar cambios de identificación a través de Altas Potenciales.</strong></span>
              </template>
              <template v-else-if="feature.properties.id_tipo_establecimiento_gn_comercial.id === 349">
                <br><span style="color:red"><strong>Este comercial está en ZEUS, solicitar cambios de identificación a través de Altas Potenciales.</strong></span>
              </template>

              <template v-else>
                <ComercialCambios
                 @triggerComercialSave="triggerComercialSave"
                ref="cambios"
                @close="close"
                @changeLocation="changeLocation"
                @getLocation="getLocation"
                @SetNewLocation="SetNewLocation"
                @comercialSaved="comercialSaved"
                v-if="!loading_comercial"
                :permisos="permisos"
                :modification="modification">
                </ComercialCambios>
              </template>
            </div>
          </b-tab>
          <b-tab title="Gestión">
            <div>
              <ComercialGestion @triggerComercialSave="triggerComercialSave" data-vv-scope="university" @calderaSaved="calderaSaved" @comercialSaved="comercialSaved" @save="saveComercial" ref="gestionTab" @close="close" :newComercial="newComercial" :feature="feature" :type="type_mapped" :permisos="permisos"></ComercialGestion>
            </div>
          </b-tab>
          <b-tab v-if="type_mapped==='caldera'" title="Info adicional">
            <div class="scroll">
              <InfoAdicional :feature="feature" :type="type_mapped" :permisos="permisos"></InfoAdicional>
            </div>
          </b-tab>
          <b-tab v-if="!newComercial" title="Visitas">
            <div class="scroll">
              <ComercialVisitas @calderaSaved="calderaSaved" @comercialSaved="comercialSaved" :feature="feature" :permisos="permisos" :type="type_mapped"></ComercialVisitas>
            </div>
          </b-tab>
          <b-tab v-if="!newComercial" title="Multimedia">
            <div class="scroll">
              <ComercialMultimedia @calderaSaved="calderaSaved" @comercialSaved="comercialSaved"  :feature="feature" :permisos="permisos" :type="type_mapped"></ComercialMultimedia>
            </div>
          </b-tab>
        </b-tabs>
      </template>
      <template v-else-if="type_mapped==='acometida'">
        <div style="width: 95%;">
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="IDI">
                  <b-form-input :value="feature.id.split('.')[1]" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código acometida">
                  <b-form-input :value="feature.properties.codacom" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código cliente">
                  <b-form-input :value="feature.properties.codcliente" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Provincia">
                  <b-form-input :value="feature.properties.nombre_provincia_ine" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Municipio">
                  <b-form-input :value="feature.properties.nombre_municipio_ine" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Población">
                  <!-- <b-form-input :value="feature.properties.amp_distribuidora" disabled></b-form-input> -->
                  <b-form-input value="-" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Status">
                  <b-form-input :value="feature.properties.amp_status_acometida" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Diámetro">
                  <b-form-input :value="feature.properties.diametro" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Material">
                  <b-form-input :value="feature.properties.material" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo red">
                  <b-form-input :value="feature.properties.amp_tipo_red" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo gas">
                  <b-form-input :value="feature.properties.amp_tipo_gas" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Propiedad">
                  <b-form-input :value="feature.properties.amp_propiedad" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Distribuidora">
                  <b-form-input :value="feature.properties.amp_distribuidora" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código obra alta">
                  <b-form-input :value="feature.properties.obraalta" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código obra baja">
                  <b-form-input :value="feature.properties.obrabaja" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </template>
      <template v-else-if="type_mapped==='planta_gasificacion'">
        <div style="width: 95%;">
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="IDI">
                  <b-form-input :value="feature.id.split('.')[1]" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código planta">
                  <b-form-input :value="feature.properties.codigo_planta" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Provincia">
                  <b-form-input :value="feature.properties.nombre_provincia_ine" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Municipio">
                  <b-form-input :value="feature.properties.nombre_municipio_ine" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Población">
                  <!-- <b-form-input :value="feature.properties.amp_distribuidora" disabled></b-form-input> -->
                  <b-form-input value="-" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Descripción">
                  <b-form-input :value="feature.properties.descripcion" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Status operativo">
                  <b-form-input :value="feature.properties.status_operativo" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Propiedad">
                  <b-form-input :value="feature.properties.propiedad" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Distribuidora">
                  <!-- <b-form-input :value="feature.properties.amp_distribuidora" disabled></b-form-input> -->
                  <b-form-input value="-" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo planta">
                  <b-form-input :value="feature.properties.tipo_planta" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo instalación">
                  <b-form-input :value="feature.properties.tipo_instalacion" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo mercado">
                  <b-form-input :value="feature.properties.tipo_mercado" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Núm. depósitos">
                  <b-form-input :value="feature.properties.n_depositos" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Núm. usuarios activo">
                  <b-form-input :value="feature.properties.n_usuarios_activos" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Latitud">
                  <b-form-input :value="feature.properties.latitud" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Longitud">
                  <b-form-input :value="feature.properties.longitud" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </template>
      <template v-else-if="type_mapped==='gasinera'">
        <div style="width: 95%;">
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="IDI">
                  <b-form-input :value="feature.id.split('.')[1]" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Provincia">
                  <b-form-input :value="feature.properties.nombre_provincia_ine" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Municipio">
                  <b-form-input :value="feature.properties.nombre_municipio_ine" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Población">
                  <!-- <b-form-input :value="feature.properties.amp_distribuidora" disabled></b-form-input> -->
                  <b-form-input value="-" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Dirección">
                  <b-form-input :value="feature.properties.direccion" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código postal">
                  <b-form-input :value="feature.properties.codigo_postal" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Denominación">
                  <b-form-input :value="feature.properties.denominacion" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Estado">
                  <b-form-input :value="feature.properties.estado" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Propiedad">
                  <b-form-input :value="feature.properties.propiedad" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Fecha apertura">
                  <b-form-input :value="feature.properties.fecha_de_apertura" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Latitud">
                  <b-form-input :value="feature.properties.latitud" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Longitud">
                  <b-form-input :value="feature.properties.longitud" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo combustible">
                  <b-form-input :value="feature.properties.tipo_de_combustible" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </template>
      <template v-else-if="type_mapped==='residencial'">
          <b-tabs>
            <b-tab title="Identificación" class="mt-1">
              <div class="scroll">
                <ResidencialIdentificacion :feature="feature"></ResidencialIdentificacion>
              </div>
            </b-tab>
            <b-tab title="Resumen" class="mt-3">
              <div class="scroll">
                <ResidencialResumen :feature="feature"></ResidencialResumen>
              </div>
            </b-tab>
            <b-tab title="Info Adicional" class="mt-3">
              <div class="scroll">
                <residencial-info-adicional :feature="feature"></residencial-info-adicional>
              </div>
            </b-tab>
          </b-tabs>
      </template>
      <template v-else-if="type_mapped==='catastro'">
          <b-row>
            <b-col>
                <b-form-group style="font-size: 1rem;" label="Referencia catastral">
                  <b-form-input :value="feature.code" disabled></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
              <b-btn size="lg" :href="feature.url" class="mt-4" target="_blank">Ver</b-btn>
            </b-col>
          </b-row>
      </template>
      <template v-else-if="type_mapped==='seccion_censal'">
        <div style="width: 95%;">
          <b-row>
            <b-col cols="4">
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código sección censal">
                  <b-form-input :value="feature.properties.codigo_seccion_censal" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <div class="box" style="margin-top:0px">
            <b-row>
                <b-col v-for="element in territorio_columns" v-bind:key="element"><strong>{{element}}</strong></b-col>
            </b-row>
            <b-row v-for="(row, index) in territorio" v-bind:key="index">
                <b-col v-for="(element, index2) in territorio_columns" v-bind:key="index2">
                  <b-row v-if="row[index2]">
                      <b-col>{{row[index2].title}}</b-col>
                      <b-col class="text-right">{{toSpanish(feature.properties[row[index2].value])}}</b-col>
                  </b-row>
                  <b-row v-else>
                      <b-col></b-col>
                      <b-col></b-col>
                  </b-row>
                </b-col>
            </b-row>
          </div>
        </div>
      </template>
    </div>
</template>

<style scoped>
.text-right{
  text-align: right;
}
.box{
  box-shadow: 0px 4px 15px 4px #0000005e;
  padding: 12px;
  margin-bottom: 15px;
  margin-top: 30px;
}

</style>

<script>
import ComercialCambios from './Details/comercial_cambios_identificacion';
import ComercialId from './Details/comercial_identificacion';
import ComercialGestion from './Details/comercial_gestion';
import ComercialVisitas from './Details/comercial_visitas';
import ComercialMultimedia from './Details/comercial_multimedia';
import InfoAdicional from './Details/info_adicional';
import NewComercial from './Details/new_comercial';
import ResidencialIdentificacion from './DetailsResidencial/Identificacion.vue';
import ResidencialResumen from './DetailsResidencial/Resumen.vue';
import ResidencialInfoAdicional from './DetailsResidencial/Infoadicional.vue';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'Details',
  components: {
    ComercialId,
    ComercialGestion,
    ComercialVisitas,
    ComercialCambios,
    ComercialMultimedia,
    InfoAdicional,
    NewComercial,
    ResidencialIdentificacion,
    ResidencialResumen,
    ResidencialInfoAdicional
  },
  props: ['feature', 'permisos'],
  data () {
    return {
      newComercial: false,
      categoria_gn_comercial_options: [],
      provincias_options: [],
      tipo_via_options: [],
      modification: null,
      loading_comercial: false,
      type: '',
      type_mapped: '',
      type_map: {
        territorio: ['zona_gn', 'municipio', 'provincia', 'codigo_postal'],
        red: ['red', 'red_inyeccion'],
        territorio_gn: ['territorio_gn', 'territorio_gn_canon_irc', 'territorio_gn_derechos_alta', 'nucleo_urbano'],
        mun_red_desplazada: ['mun_red_desplazada'],
        comercial: ['comercial'],
        caldera: ['caldera'],
        acometida: ['acometida'],
        planta_gasificacion: ['plantas_glp', 'plantas_gnl'],
        gasinera: ['gasinera'],
        seccion_censal: ['seccion_censal'],
        residencial: ['residencial_unifamiliar', 'residencial_plurifamiliar', 'residencial_bifamiliar'],
        catastro: ['Parcela catastro', 'catastro']
      },
      territorio_columns: ['Resumen Fincas', 'Resumen PS', 'Resumen Potencial'],
      territorio: [
        [{title: 'Total Fincas', value: 'total_fincas'}, {title: 'Total PS', value: 'total_ps'}, {title: 'PS NE', value: 'ps_potencial_ne'}],
        [{title: 'Activas', value: 'total_fincas_activos'}, {title: 'PS Activos', value: 'ps_activos'}, {title: 'PS CC', value: 'ps_potencial_cc'}],
        [{title: 'Potenciales', value: 'total_fincas_potenciales'}, {title: 'PS Potenciales', value: 'ps_potenciales'}, {title: 'PS GC', value: 'ps_potencial_gc'}],
        [{title: 'Captadas', value: 'total_fincas_captadas'}, {title: 'PS Captados', value: 'ps_captados'}, {title: 'PS PYME', value: 'ps_potencial_pyme'}],
        [{title: 'Con Residencial', value: 'total_fincas_con_residencial'}, {title: 'PS Gestión', value: 'ps_en_gestion'}, {title: 'PS SV', value: 'ps_potencial_sv'}],
        [{title: 'Con Comercial', value: 'total_fincas_con_comercial'}, {title: 'PS No Captable', value: 'ps_no_captables'}, {title: 'PS SH', value: 'ps_potencial_sh'}],
        [{title: 'Con Industrial', value: 'total_fincas_con_industrial'}, {title: 'PS Activos GN', value: 'ps_activos_gn'}, {title: 'PS SP', value: 'ps_potencial_sp'}],
        [{title: 'Con C.Caldera', value: 'total_fincas_con_cuarto_de_caldera'}, {title: 'PS Activos GLP', value: 'ps_activos_glp'}, {title: 'PS ES', value: 'ps_potencial_es'}],
        [{}, {title: 'PS Residencial', value: 'ps_residencial'}, {title: 'PS CCNE', value: 'ps_potencial_ccne'}],
        [{}, {title: 'PS Comercial', value: 'ps_comercial'}, {}],
        [{}, {title: 'PS Industrial', value: 'ps_industrial'}, {}],
        [{}, {title: 'PS C.Calderas', value: 'ps_cuarto_de_caldera'}, {}]
      ],
      red: [
        [{title: 'Status', value: 'amp_status_subtramo_red'}, {title: 'Presión', value: 'presoper'}, {title: 'Diámetro', value: 'diametro'}, {title: 'Material', value: 'material'}],
        [{title: 'Tipo red', value: 'amp_tipo_red'}, {title: 'Tipo gas', value: 'amp_tipo_gas'}, {title: 'Propiedad', value: 'propied'}, {title: 'Distribuidora', value: 'amp_distribuidora'}],
        [{title: 'Código Obra Alta', value: 'obraalta'}, {title: 'Código Obra Baja', value: 'obrabaja'}, {title: 'Código Red', value: 'redegas'}, {title: 'Caudal máximo Inyección', value: 'caudal_minimo'}]
      ]
    };
  },
  mounted: function () {
    if (!this.feature.catastro) {
      this.type = this.feature.id.split('.')[0];
    } else {
      this.type = this.feature.tipo_name;
    }
    this.type_mapped = '';

    for (let index = 0; index < Object.keys(this.type_map).length; index++) {
      const element = Object.keys(this.type_map)[index];
      if (this.type_map[element].indexOf(this.type) > -1) {
        this.type_mapped = element;
      }
    }
    if (this.type === 'comercial') {
      if (this.feature.id.split('.')[1]) {
        this.loading_comercial = true;
        this.$http.get('correccion_comercial/' + this.feature.id.split('.')[1] + '/').then(result => {
          this.modification = result.data;

          this.modification.new = false;
          this.loading_comercial = false;
        }, e => {
          this.modification = {
            'new': true,
            'anexo': null,
            'codigo_cnae': null,
            'codigo_municipio_zeus': null,
            'codigo_poblacion_zeus': null,
            'codigo_postal': null,
            'codigo_provincia_zeus': null,
            'codigo_via': null,
            'create_date': null,
            'create_user': 'script reins',
            'direccion_no_estructurada': null,
            'eliminado': false,
            'eliminado_create_date': null,
            'eliminado_create_user': null,
            'eliminado_motivo': null,
            'geom': null,
            'id_categoria_gn_comercial': null,
            'id_comercial': this.feature.id.split('.')[1],
            'id_precision_coordenada': null,
            'id_tipo_establecimiento_comercial': null,
            'latitud': null,
            'longitud': null,
            'municipio': null,
            'nombre': null,
            'nombre_via': null,
            'numero': null,
            'poblacion': null,
            'provincia': null,
            'resto_direccion': null,
            'tipo_via': null,
            'update_date': null,
            'update_user': null
          };
          this.loading_comercial = false;
        });
      } else {
        this.newComercial = true;
        this.modification = {
          'anexo': null,
          'codigo_cnae': null,
          'codigo_municipio_zeus': null,
          'codigo_poblacion_zeus': null,
          'codigo_postal': null,
          'codigo_provincia_zeus': null,
          'codigo_via': null,
          'create_date': null,
          'create_user': 'script reins',
          'direccion_no_estructurada': null,
          'eliminado': false,
          'eliminado_create_date': null,
          'eliminado_create_user': null,
          'eliminado_motivo': null,
          'geom': null,
          'id_categoria_gn_comercial': null,
          'id_comercial': null,
          'id_precision_coordenada': null,
          'id_tipo_establecimiento_comercial': null,
          'latitud': null,
          'longitud': null,
          'municipio': null,
          'nombre': null,
          'nombre_via': null,
          'numero': null,
          'poblacion': null,
          'provincia': null,
          'resto_direccion': null,
          'tipo_via': null,
          'update_date': null,
          'update_user': null
        };
      }
    } else if (this.type === 'caldera') {
      this.loading_comercial = false;
    }
  },
  methods: {

    triggerComercialSave: function (tipo) {
      // console.log('DETAILS')
      if (tipo === 'cambios') {
        // Possible race condition. Both update a commercial instance.
        // More info https://github.com/encode/django-rest-framework/issues/4675
        this.$refs.identificacionTab.save(false, true, () => {
          this.$refs.gestionTab.save(false, true);
        });
      } else if (tipo === 'identificacion') {
        this.$refs.gestionTab.save(false, true);
        this.$refs.cambios.saveModification(false, true);
      } else if (tipo === 'gestion') {
        this.$refs.identificacionTab.save(false, true);
        this.$refs.cambios.saveModification(false, true);
      }
    },
    comercialSaved: function () {
      this.$emit('comercialSaved');
    },
    calderaSaved: function () {
      this.$emit('calderaSaved');
    },
    saveComercial: function () {
      this.$refs.saveTab.$validator.validate().then(result => {
        let errorsTipoEstablecimiento = !this.$refs.saveTab.validTipoEstablecimiento();
        if (!result || errorsTipoEstablecimiento) {
          alert('Tienes algún error en el formulario');
        } else {
          this.$refs.gestionTab.$validator.validate().then(result => {
            if (!result) {
              alert('Tienes algún error en el formulario');
            } else {
              const tab1 = this.$refs.saveTab.save();
              const tab2 = this.$refs.gestionTab.saveNew();

              var comercial = JSON.parse(JSON.stringify(tab1));

              comercial.id_categoria_gn_comercial = tab1.id_categoria_gn_comercial.id;
              // comercial.id_clase_establecimiento_gn_comercial = tab1.id_clase_establecimiento_gn_comercial.id
              // tab1.id_gas_finca = tab1.id_gas_finca.id
              comercial.id_precision_coordenada = tab1.id_precision_coordenada.id;
              // tab1.id_status_gestion_comercial = tab1.id_status_gestion_comercial.id
              comercial.id_tipo_establecimiento_gn_comercial = tab1.id_tipo_establecimiento_gn_comercial.id;

              if (tab1.codigo_cnae !== undefined && tab1.codigo_cnae !== null) {
                comercial.codigo_cnae = tab1.codigo_cnae.id;
              } else {
                comercial.codigo_cnae = null;
              }

              comercial.id_gas_finca = tab2.id_gas_finca.id;
              comercial.id_status_gestion_comercial = tab2.id_status_gestion_comercial.id;
              comercial.id_clase_establecimiento_gn_comercial = tab2.id_clase_establecimiento_gn_comercial.id;

              comercial.update_date = null;
              comercial.update_user = null;
              // this.$refs.saveTab.loading = 0
              // this.$refs.gestionTab.loading = 0

              this.$http.post(this.type + '/', comercial).then(result => {
                alert('Guardado con éxito!');
                this.$refs.saveTab.loading = 0;
                this.$refs.gestionTab.loading = 0;
                this.close();
              });
            }
          });
        }
      });
    },
    close: function () {
      this.$emit('close');
    },
    changeLocation: function (modification) {
      this.$parent.$parent.changeLocation(modification);
    },
    getLocation: function (modification = null) {
      this.$parent.$parent.localizar2(modification);
    },
    SetNewLocation: function () {
      this.$parent.$parent.SetNewLocation();
    },
    toSpanish: function (v) {
      if (v) {
        return v.toLocaleString('es');
      } else {
        return '';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details.vue